<template>
  <div>
    <div class="row">
      <div class="col-12">
        <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
          <div class="card">
            <div class="loader-container" v-if="loading">
              <Loader />
              <div class="loader-message">
                Lade Ihre Einheiten
              </div>
            </div>
            <transition
              :name="animations.standard.name"
              :enter-active-class="animations.standard.enter"
              :leave-active-class="animations.standard.leave"
            >
              <div class="card-header" v-if="!loading"><h4>Meine Einheiten</h4></div>
            </transition>
            <transition
              :name="animations.standard.name"
              :enter-active-class="animations.standard.enter"
              :leave-active-class="animations.standard.leave"
            >
              <div class="card-body" v-if="!loading">
                <div class="table-responsive datatable-vue clickable-rows">
                  <b-table
                    :items="kunde_wohnungen"
                    :fields="tbl_fields"
                    :filter="tbl_filter"
                    @row-clicked="routeToWohnung"
                    v-if="kunde_wohnungen.length"
                  >
                    <template slot="empty">
                      Keine Wohnungen gefunden.
                    </template>
                    <template v-slot:cell(aktionen)="row">
                      <feather class="infra-blue pointer" type="link" @click="$router.push('wohnung/' + row.item.id)"></feather>
                    </template>
                  </b-table>
                </div>
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/LoaderRelative.vue";

export default {
  name: "KundeWohnungen",
  components: {
    Loader,
  },
  data() {
    return {
      tbl_fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "haus.name", label: "Haus", sortable: true },
        { key: "haus.haus_bp.name", label: "Bauprojekt", sortable: true },
        { key: "aktionen", label: "Optionen", sortable: false },
      ],
      loading: false,
      loaderMessage: "",
      tbl_totalRows: 1,
      tbl_currentPage: 1,
      tbl_perPage: 10,
      tbl_filter: null,
    };
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      kunden: "app/kunden",
      toasts: "app/toasts",
      readyState: "app/readyState",
      board_bauprojekte: "msg/bauprojekte",
      board_hauser: "msg/hauser",
      board_wohnungen: "msg/wohnungen",
      board_dienstleister: "msg/dienstleister",
      animations: "app/animations",
      user: "auth/user",
      kunde: "auth/kou",
      kunde_wohnungen: "app/kuwo",
    }),
  },
  async created() {
    try {
      this.loading = true;
      this.loaderMessage = "Lade Bauprojekte...";
      if (!this.bauprojekte) {
        await this.$store.dispatch("app/apiGetBauprojekte");
        this.loaderMessage = "Lade Häuser...";
      }

      if (!this.hauser) {
        await this.$store.dispatch("app/apiGetHouses");
        this.loaderMessage = "Lade Wohnungen...";
      }

      if (!this.wohnungen) {
        await this.$store.dispatch("app/apiGetWohnungen");
      }

      this.loaderMessage = "Lade Kundendaten...";
      if (!this.kunden) {
        await this.$store.dispatch("app/apiGetKunden");
      }

      if (!this.readyState.kunde_wohnungen) {
        console.log("starting getKundeWohnunen in parent");
        await this.$store.dispatch("app/getKundeWohnungen", this.kunde.id);
      }
    } catch (error) {
      console.log(error);
      this.$toasted.show(error, this.toasts.failure);
    } finally {
      this.loading = false;
      this.loaderMessage = "";
    }
  },
  methods: {
    routeToWohnung(record) {
      this.$router.push("wohnung/" + record.id);
    },
  },
};
</script>

<style></style>
